import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 📝 Request Variables

Request variables are defined specifically for a single request and are not shared across other requests or collections. They are ideal for storing temporary values or data generated or modified during a particular request lifecycle.

HawkClient supports two types of request variables:

- **Pre-request Variables:** Defined and used before a request is sent. Useful to set dynamic headers, query parameters, or body values.
- **Post-response Variables:** Set after the request is completed and can be populated using values from the response, such as tokens or IDs for chaining requests.

These variables can be referenced within the same request using the \`{{variableName}}\` syntax and have the highest precedence, overriding environment, collection, and global variables if the same key exists.

![Request Variables](/docs/variables.png)

## ⚡ Pre-Request

Pre-request variables are key-value pairs defined specifically for a single request and are evaluated right before the request is sent. They are scoped only to the current request.

## 📩 Post-Response

Post-response variables allow you to extract data from the response and assign it to variables at a broader scope such as **Environment, Global,** or **Collection**. Each entry includes:

- **Scope:** Where the variable should be saved (e.g., env, global, collection).
- **Key:** The name of the variable.
- **Value/Expression:** The data to store, which can be derived from the response object.

### Supported Fields for Post-Response Expressions

You can use the following fields from the response to populate post-response variables dynamically:

- **response.body** – the parsed response body (JSON or text)
- **response.status** – HTTP status code
- **response.statusText** – status message text
- **response.headers** – headers returned from the server

You can also access nested values from a JSON response. For example, if the response body is:

\`\`\`json
{
  "user": {
    "token": "abc123"
  }
}
\`\`\`

You can use **response.body.user.token** to extract and store the token value.

These extracted values can then be reused in subsequent requests within the same workspace, making it easy to chain requests or manage dynamic data across flows.
`;

const RequestVariables = () => {
    return (
        <MarkDownRenderer
            title="Request Variables"
            markDownText={markdownContent}
        />
    );
};

export default RequestVariables;
